export default __webpack_public_path__ + "static/media/qr-code-scan-2.aa02c53d.png";